import React, {FC, useEffect} from "react";
import cls from "./forms.module.scss"
import {
    Button,
    Checkbox,
    Heading,
    Input,
    InputDate,
    InputFile,
    InputNumber,
    Radio,
    Select,
    TextArea,
} from "./FormAtoms";
import {useDispatch} from "react-redux";
import {addAndResetForm, setFormElementValue, setFormErrors} from "../../../store/formbuilder";
import {TranslationsType} from "../../../types/homePageTypes";
import {IFormComponentType} from "../types";


interface IProps {
    item: {
        customClassNames: string;
        buttonValue: string;
        settings: [];
        convertedSettings: {
            animationAos: { "data-aos": any },
            styles: any;
            parentStyles: any
        };
        blog: {
            blogs: Array<any>,
            category: {
                id: number,
                slug: string
            },
            quantity: number
        };
        form: {
            id: number,
            name: string
        },
        formComponentInfo: IFormComponentType
        linkValueButton: {
            id: string;
            value: string;
            checked: boolean
        }
    },
    recaptchaActive: string;
    productInfo?: {
        sku: string,
        image: string;
        name: string
    };
    translationsData: TranslationsType
}

const FormBuilderComponent: FC<IProps> = (
    {
        item: {
            customClassNames,
            convertedSettings: {
                styles = {}
            } = {},
            formComponentInfo: {
                data: {
                    id,
                    code,
                    form_builder_json = []
                } = {}
            } = {}
        },
        recaptchaActive,
        productInfo,
        translationsData
    }
) => {
    const chartWidthHandle = () => {
        const margin = (styles?.margin as string) || "0px";
        const splittedMargins = margin.split(" ");
        const [top = "0px", right = "0px", bottom = "0px", left = "0px"] = splittedMargins;
        const isZeroMargin = [top, right, bottom, left].every(val => val === "0px");
        return isZeroMargin ? "100%" : `calc(100% - ${right} - ${left})`;
    }
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(addAndResetForm({
            id: id as number,
            formData: form_builder_json
        }))
        dispatch(setFormErrors({}))
    }, []);

    useEffect(() => {
        let formBuilderArr = null;
        if (form_builder_json?.length > 0) {
            formBuilderArr = form_builder_json?.map((elem, index) => ({...elem, index}))
        }
        const hiddenSkuField = formBuilderArr?.find(elem => elem?.type === "hidden" && elem?.value.toLowerCase() === "sku")
        const hiddenPageUrlField = formBuilderArr?.find(elem => elem?.type === "hidden" && elem?.value.toLowerCase() === "pageurl")
        if (productInfo?.sku && hiddenSkuField) {
            dispatch(setFormElementValue({
                id: id as number,
                index: hiddenSkuField?.index,
                fieldsForChange: {
                    forSku: true,
                    value: productInfo.sku
                }
            }))
        }
        if (hiddenPageUrlField) {
            dispatch(setFormElementValue({
                id: id as number,
                index: hiddenPageUrlField?.index,
                fieldsForChange: {
                    forPageUrl: true,
                    value: window.location.href
                }
            }))
        }
    }, []);

    const handleElement = (elem: any, index: number): Record<string, React.JSX.Element> => {
        return {
            "header": <Heading key={index} formId={id as number} index={index} element={elem}/>,
            "paragraph": <Heading key={index} formId={id as number} index={index} element={elem}/>,
            "text": <Input translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "number": <InputNumber translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "date": <InputDate translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "file": <InputFile translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "button": <Button key={index} formId={id as number} formCode={code as string} index={index} element={elem} formData={form_builder_json} recaptchaActive={recaptchaActive}/>,
            "checkbox-group": <Checkbox translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "radio-group": <Radio translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "textarea": <TextArea translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>,
            "select": <Select translationsData={translationsData} key={index} formId={id as number} index={index} element={elem}/>
        }
    }

    return <div
        className={`${cls.form} ${customClassNames}`}
        style={{
            margin: styles?.margin,
            padding: styles?.padding,
            width: chartWidthHandle()
        }}
        // data-aos={animation}
    >
        {form_builder_json.map((el, index) => {
            return handleElement(el, index)[el.type]
        })}
    </div>
}

export default FormBuilderComponent;